// src/components/Common/Toast/toastUtils.tsx

import { toast } from "react-toastify";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import React from "react";

export const showSuccessToast = (message: string) => {
    toast.success(message, {
        position: toast.POSITION.TOP_CENTER,
        theme: "colored",
        icon: <CheckboxIcon height={25} width={25} fill="white" />,
    });
};
